// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__xBQ3E","tab":"Tabs_tab__BmDiW","tabActive":"Tabs_tabActive__2MYSU"};